// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import Checkbox from 'material-ui/Checkbox';

import TitledCard from 'common/components/cards/TitledCard';
import Other from './Other';
import type { StreamConfigurationFormSection, StreamTypesData } from '../../domain/StreamConfiguration';

type Props = {
  onChange: (value: StreamConfigurationFormSection) => void,
  data: StreamTypesData,
  t: any,
}

function StreamingTypes(props: Props) {
  return (
    <TitledCard title={props.t('streamTypes')} >
      <div className="row">
        <div className="col-xs-3">
          <Checkbox
            label={'AAC'}
            name="aac"
            onCheck={(e, v) => props.onChange({ ...props.data, aac: v })}
            checked={props.data.aac}
          />
        </div>
        <div className="col-xs-3">
          <Checkbox
            label={'MP3'}
            name="mp3"
            onCheck={(e, v) => props.onChange({ ...props.data, mp3: v })}
            checked={props.data.mp3}
          />
        </div>
        <div className="col-xs-3">
          <Checkbox
            label={'MP3U'}
            name="mp3u"
            onCheck={(e, v) => props.onChange({ ...props.data, mp3u: v })}
            checked={props.data.mp3u}
          />
        </div>
        <div className="col-xs-3">
          <Checkbox
            label={'M3UB'}
            name="m3ub"
            onCheck={(e, v) => props.onChange({ ...props.data, m3ub: v })}
            checked={props.data.m3ub}
          />
        </div>
      </div>
      <Other onChange={(k, v) => props.onChange({ ...props.data, [k]: v })} data={props.data} />
    </TitledCard>
  );
}

export default translate('radioConfiguration')(StreamingTypes);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/streamConfigurationForm/StreamingTypes.js